var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleTriangleUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "akar-icons:circle-triangle-up-fill",
    clipPath: "url(#clip0_7477_5988)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 541",
    cx: 8,
    cy: 7.66667,
    rx: 4,
    ry: 3.66667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00033 0.666016C3.95033 0.666016 0.666992 3.94935 0.666992 7.99935C0.666992 12.0493 3.95033 15.3327 8.00033 15.3327C12.0503 15.3327 15.3337 12.0493 15.3337 7.99935C15.3337 3.94935 12.0503 0.666016 8.00033 0.666016ZM5.86699 9.33268C5.77239 9.33371 5.67918 9.30986 5.59669 9.26353C5.51421 9.21719 5.44534 9.15 5.39699 9.06868C5.35152 8.98964 5.32984 8.89915 5.33457 8.80808C5.3393 8.71701 5.37024 8.62925 5.42366 8.55535L7.55699 5.55535C7.60809 5.4859 7.6749 5.42953 7.75195 5.39083C7.829 5.35213 7.91411 5.33221 8.00033 5.33268C8.17899 5.33268 8.34499 5.41602 8.44433 5.55535L10.5777 8.55535C10.6311 8.62925 10.662 8.71701 10.6667 8.80808C10.6715 8.89915 10.6498 8.98964 10.6043 9.06868C10.5559 9.1501 10.4869 9.21735 10.4043 9.26369C10.3217 9.31003 10.2284 9.33382 10.1337 9.33268H5.86699Z",
    fill: "#FEBF5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7477_5988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTriangleUp);
export default __webpack_public_path__ + "static/media/circle-triangle-up.6225a134b64a4dc61a2b144996293fb4.svg";
export { ForwardRef as ReactComponent };